module.exports = __webpack_public_path__ + "static/media/logo_cliquei.7e98d363.svg";